/**
 * @author lihh
 * @description 表示关于聊天的相关的接口
 */
// 导入axios
import request from "@/utils/request";

import {
    SERVICE_TYPE_HPO,
    SERVICE_TYPE_HPE,
    SERVICE_TYPE_HPM,
} from "@/utils/define";

/**
 * @author lihh
 * @description 获取环形的token  以及用户id
 */
export function getConcatToken(data = {}) {
    // 表示需要toekn
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/accountToken?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 获取所有发过消息的用户
 */
export function getRoster(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getRoster?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 保存发消息的用户
 */
export function saveRoster(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/saveRoster?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 修改聊天状态
 */
export function updateChatStatus(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/oldChat?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 获取所有发布职位
 */
export function getPublishJob(data = { state: "1", size: 99 }) {

    return request({
        url: `/${ SERVICE_TYPE_HPE }/ComJob/JobsGet`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 获取简历基本信息
 */
export function getResumeInfo(data = {}) {

    return request({
        url: `/${ SERVICE_TYPE_HPE }/talentsearchCU/ById`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 修改用户选择的职位
 */
export function exchangePosition(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/exchangePosition`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 对消息管理的好友进行排序
 */
export function sortRoster(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/sortRoster?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 根据创建者id获取信息内容
 */
export function getRosterById(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getRosterById?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 查询交换过的手机号 微信号
 */
export function exchangeContact(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/exchangeContact?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 保存手机号 或是 微信号
 */
export function saveContact(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/saveContact?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @auhtor lihh
 * @description 拒绝手机号 或是 微信号的交换
 */
export function rejectContact(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/rejectContact?type=stu`,
        method: "POST",
        data,
    });
}

export function getRejectState(data = {}) {
    data["tokenNeed"] = 1;
    data['isLoading'] = false;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getRejectState?type=stu`,
        method: "POST",
        data,
    });
}

export function rejectReply(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/rejectReply?type=stu`,
        method: "POST",
        data,
    });
}

export function ifApply(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/ifApply`,
        method: "POST",
        data,
    });
}

export function jobApplyA(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/Operate/JobApplyA`,
        method: "POST",
        data,
    });
}

export function getReplyState(data = {}) {
    data["tokenNeed"] = 1;
    data["isLoading"] = false;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getReplyState?type=stu`,
        method: "POST",
        data,
    });
}

export function saveReply(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/saveReply?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 对好友进行删除
 */
export function removeRoster(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/removeRoster?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 切换职位获取列表
 */
export function byHrId(hrId, size, current, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/Job/ByHrId?hrId=${ hrId }&size=${ size }&current=${ current }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 切换职位获取列表
 */
 export function onLineJob(hrId,data = {}) {
  data["tokenNeed"] = 1;
  return request({
      url: `/${SERVICE_TYPE_HPM}/Job/onLineJob?hrId=${hrId}`,
      method: 'POST',
      data
  });
}

/**
 * @author lvcx
 * @description 查看HR资料
 */
export function GetHrData(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/Com/GetHrData?hrId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 更新最后的会话事件
 */
export function updateLastSesstionTime(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/updateTime?type=stu`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 更新最后的会话事件  JobsName
 */
export function JobsName(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/Job/AllJob?hrId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 加入群聊
 * @id 群id
 */
export function joinGroup(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/joinGroup?groupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 获取群列表
 */
export function getGroups(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getGroups`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 获取群信息
 */
export function getGroup(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getGroup?groupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 获取群成员信息
 */
export function getMembers(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getMembers?groupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 根据群 用户id 查询个人具体信息
 */
export function getMembersById(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getMembersById`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 页面离开时群排序
 */
export function sortGroups(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/sortGroups`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 消息免打扰
 */
export function disturbGroup(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/disturbGroup?groupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 群聊天置顶
 */
export function topGroup(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/topGroup?groupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 查询群中的所有的人(包括已经离开的人)
 * @param groupId 表示群id
 * @return {AxiosPromise}
 */
export function getAllMembers(groupId) {
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getAllMembers?groupId=${ groupId }`,
        method: "POST",
        data: { tokenNeed: 1 },
    });
}

/**
 * @author lvcx
 * @description 退出群聊
 */
export function quitGroup(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/quitGroup?groupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 获取群聊答疑未读条数
 */
export function getNoReadNum(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/getNoReadNum?hxGroupId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 获取群列表
 */
export function getGroupsById(id, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/getGroupsByJobId?jobId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author wangl
 * @description 举报HR
 */
export function complainHr(data = {}) {

    // 表示需要token
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/complainHr`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 向hr提问
 */
export function question(data = {}) {
    // 表示需要token
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/question`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 查询提问列表
 */
export function questionList(data = {}) {
    // 表示需要token
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/questionList`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 对我感兴趣
 */
export function interestIn(current, size, data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/interestIn?current=${ current }&size=${ size }`,
        method: "POST",
        data,
    });
}

/**
 * @author lvcx
 * @description 聊天中设置不合适
 */
export function setInterest(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPM }/HX/setInterest`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 查询单聊 或是 群聊的未读个数
 */
export function getMsgNoReadNum(userId = "", data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getNoReadNum?userId=${ userId }`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 初次沟通获取职位卡片详情
 */
export function getJobInfo(id = "", data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getJobInfo?jobId=${ id }`,
        method: "POST",
        data,
    });
}

/**
 * @author lihh
 * @description 获取群二维码
 * @param groupId 表示群id
 */
export function getQrCode(groupId) {
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getQrCode?groupId=${ groupId }`,
        method: "POST",
        data: { tokenNeed: 1 },
    });
}

/**
 * @author wangl
 * @description 群职位
 */
export function GroupJobsList(data = {}) {
    data["tokenNeed"] = 1;
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/GroupJobsList`,
        method: "POST",
        data,
    });
}

/**
 * @author wangl
 * @description 群公告
 */
export function getGroupDesc(hxGroupId) {
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/getGroupDesc?hxGroupId=${ hxGroupId }`,
        method: "POST",
        data: { tokenNeed: 1 },
    });
}

/**
 * @author lihh
 * @description 查询消息是否撤回
 * @param mid 表示消息撤回id
 */ 
export function ifRecall(mid) {
    return request({
        url: `/${ SERVICE_TYPE_HPO }/HX/ifRecall?mid=${ mid }`,
        method: "POST",
        data: { tokenNeed: 1, isLoading: false },
    });
}

/**
 * @description 根据附件ID 获取七牛地址
 */
 export function getAttachmentId(id,data = {}) {
  data["tokenNeed"] = 1;
  return request({
      url: `/${ SERVICE_TYPE_HPM }/Resume/DownLoadAttachmentUrl?attachmentId=${id}`,
      method: "POST",
      data,
  });
}

/**
 * @description 获取消息通知列表
 */
 export function getMessages(current,size,data = {}) {
  data["tokenNeed"] = 1;
  return request({
      url: `/${SERVICE_TYPE_HPM}/User/Messages?current=${current}&size=${size}`,
      method: 'POST',
      data
  });
}

/**
 * @description 消息通知单条已读未读
 */
 export function ReadMessage(id,data = {}) {
  data["tokenNeed"] = 1;
  return request({
      url: `/${SERVICE_TYPE_HPM}/Operate/ReadMessage?id=${id}`,
      method: 'POST',
      data
  });
}

/**
 * @description 消息通知所有已读
 */
 export function ReadMessageAll(data = {}) {
  data["tokenNeed"] = 1;
  return request({
      url: `/${SERVICE_TYPE_HPM}/Operate/ReadMessageAll`,
      method: 'POST',
      data
  });
}

/**
 * @description 获取未读的数字个数
 */
 export function MyChatNum(data = {}) {
  data["tokenNeed"] = 1;
  data['isLoading'] = false;
  return request({
      url: `/${SERVICE_TYPE_HPM}/User/MyChatNum`,
      method: 'POST',
      data
  });
}



// WEBPACK FOOTER //
// ./src/api/request/concatService.js